module.exports = __webpack_public_path__ + "static/media/logo-bt.9099477c.svg";